module.exports = __webpack_public_path__ + "static/sangeet-60d02cbc95730c9c9eb3190753c5aea3.png";